import type { AnyAction, Store } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { createWrapper, type MakeStore } from 'next-redux-wrapper';

import { reducer as rootReducer } from './reducer';
import type { AccommodationState } from '@/interfaces';

// This function is exported for mocking and retrieving `store` in tests
const makeStore = ({
    preloadedState,
    reduxWrapperMiddleware,
}: {
    // biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
    reduxWrapperMiddleware: any;
    preloadedState?: AccommodationState;
    reducer?: ReturnType<typeof rootReducer>;
}) =>
    configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: (getDefaultMiddleware) => [...getDefaultMiddleware(), reduxWrapperMiddleware],
    });

export const wrapper = createWrapper<Store<AccommodationState>>(makeStore as unknown as MakeStore<Store<AccommodationState, AnyAction>>, {
    debug: false,
});

type AppStore = ReturnType<typeof makeStore>;
export type AppDispatch = AppStore['dispatch'];
